"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadiusPill = exports.borderRadiusXlarge = exports.borderRadiusLarge = exports.borderRadiusMedium = exports.borderRadiusSmall = exports.borderRadiusTiny = exports.controlBorderRadiusPill = exports.controlBorderRadiusLarge = exports.controlBorderRadiusMedium = exports.controlBorderRadiusSmall = exports.actionBorderRadiusPill = exports.actionBorderRadiusLarge = exports.actionBorderRadiusMedium = exports.actionBorderRadiusSmall = exports.baseBorderRadiusXlarge = exports.baseBorderRadiusLarge = exports.baseBorderRadiusMedium = exports.baseBorderRadiusSmall = void 0;
exports.baseBorderRadiusSmall = 4;
exports.baseBorderRadiusMedium = 6;
exports.baseBorderRadiusLarge = 8;
exports.baseBorderRadiusXlarge = 16;
exports.actionBorderRadiusSmall = 2;
exports.actionBorderRadiusMedium = 4;
exports.actionBorderRadiusLarge = 6;
exports.actionBorderRadiusPill = 200;
exports.controlBorderRadiusSmall = 4;
exports.controlBorderRadiusMedium = 6;
exports.controlBorderRadiusLarge = 8;
exports.controlBorderRadiusPill = 200;
exports.borderRadiusTiny = 2;
exports.borderRadiusSmall = 4;
exports.borderRadiusMedium = 6;
exports.borderRadiusLarge = 8;
exports.borderRadiusXlarge = 16;
exports.borderRadiusPill = 200;